<div [innerHTML]="htmlContent"></div>
<div class="filter-btn-disabled filter-save-btn" [routerLink]="['/dashboard']">
  <button mat-raised-button> Schließen </button>
</div>
